import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2168fdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "import-data-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Imported School Data", -1))
const _hoisted_3 = { class: "data-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "School Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Address"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "District")
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "expand-icon" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "School Name:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Address:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Type:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "District:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Town:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Zipcode:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Phone:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Grades:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Student Open Date:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Magnet:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Latitude:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Longitude:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
      placeholder: "Search by name or address...",
      class: "search-input"
    }, null, 512), [
      [_vModelText, _ctx.searchQuery]
    ]),
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchools, (school, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: school.organization_code
          }, [
            _createElementVNode("tr", {
              onClick: ($event: any) => (_ctx.toggleExpand(index)),
              class: "expandable-row"
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.expandedIndex === index ? "▼" : "▶"), 1),
                _createTextVNode(" " + _toDisplayString(school.name), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(school.address), 1),
              _createElementVNode("td", null, _toDisplayString(school.organization_type), 1),
              _createElementVNode("td", null, _toDisplayString(school.district_name), 1)
            ], 8, _hoisted_5),
            (_ctx.expandedIndex === index)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(school.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(school.address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(school.organization_type), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(school.district_name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(school.town), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(school.zipcode), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(school.phone), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createTextVNode(" Pre-K: " + _toDisplayString(school.prekindergarten) + ", K: " + _toDisplayString(school.kindergarten) + ", 1: " + _toDisplayString(school.grade_1) + ", 2: " + _toDisplayString(school.grade_2) + ", 3: " + _toDisplayString(school.grade_3) + ", 4: " + _toDisplayString(school.grade_4) + ", 5: " + _toDisplayString(school.grade_5) + ", 6: " + _toDisplayString(school.grade_6) + ", 7: " + _toDisplayString(school.grade_7) + ", 8: " + _toDisplayString(school.grade_8) + ", 9: " + _toDisplayString(school.grade_9) + ", 10: " + _toDisplayString(school.grade_10) + ", 11: " + _toDisplayString(school.grade_11) + ", 12: " + _toDisplayString(school.grade_12), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(new Date(school.student_open_date).toLocaleDateString()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(school.interdistrict_magnet === "1" ? "Yes" : "No"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(school.geocoded_column.latitude), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createTextVNode(" " + _toDisplayString(school.geocoded_column.longitude), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}